import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=71750a79&scoped=true&"
import script from "./banner.js?vue&type=script&lang=js&"
export * from "./banner.js?vue&type=script&lang=js&"
import style0 from "./banner.scss?vue&type=style&index=0&id=71750a79&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71750a79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71750a79')) {
      api.createRecord('71750a79', component.options)
    } else {
      api.reload('71750a79', component.options)
    }
    module.hot.accept("./banner.vue?vue&type=template&id=71750a79&scoped=true&", function () {
      api.rerender('71750a79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/kl-xiaodai/index/component/banner/banner.vue"
export default component.exports